import React from 'react';
import { Team } from '../../services/api';
import { Users } from 'lucide-react';
import './TeamsTab.css';

interface TeamsTabProps {
  teams: Team[];
}

const TeamsTab: React.FC<TeamsTabProps> = ({ teams }) => {
  return (
    <div className="teams-section">
      {teams.length === 0 ? (
        <div className="empty-state">No teams assigned to this case</div>
      ) : (
        <div className="teams-grid">
          {teams.map((team) => (
            <div key={team.teamId} className="team-card">
              <div className="team-header">
                <h3>
                  <Users size={20} /> {team.teamName}
                </h3>
                {team.description && <p className="team-description">{team.description}</p>}
              </div>
              <div className="team-members">
                <h4 className="team-members-header">Members ({team.members?.length || 0})</h4>
                {team.members && team.members.length > 0 ? (
                  <div>
                    {team.members.map((member, idx) => (
                      <div key={`${member.userId}-${idx}`} className="team-member">
                        <div>
                          <div className="member-name">{member.userName}</div>
                          <div style={{ color: 'hsl(0, 0%, 65%)', fontSize: '0.85rem', marginTop: '0.25rem' }}>
                            {member.userEmail}
                          </div>
                        </div>
                        {member.accessLevel && (
                          <span className="member-role">Level {member.accessLevel}</span>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ color: 'hsl(0, 0%, 65%)', marginTop: '0.5rem' }}>No members assigned</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamsTab;

